export default __webpack_public_path__ + "static/media/nftHive.5aa0c3e2.svg";